module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-lorelei.json
// module id = 410
// module chunks = 75044597648265